import { defineComponent as _defineComponent } from 'vue'
import {
  QuotePriceResponse,
  Wallet,
  getBuyCcy,
  getSellCcy,
  getPrimaryCcy,
  getSecondaryCcy,
  formatHedgingInstrument,
} from 'ah-api-gateways';
import { isToday, parseISO } from 'date-fns';
import { FULL_DATE_FORMAT } from 'ah-common-lib/src/helpers/time';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { useAhTradesState } from '../..';
import { formatInTimeZone } from 'date-fns-tz';
import { computed, reactive, watch } from 'vue';
import { useOnBehalfOf } from 'ah-common-lib/src/onBehalfOf/useInjectedOBO';
import TradesFormattedCurrency from '../../currency/TradesFormattedCurrency.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TradeDetailsInfo',
  props: {
    tradePriceResponse: null
  },
  setup(__props: any) {

const props = __props as {
  /**
   * Trade price response object
   */
  tradePriceResponse: QuotePriceResponse;
};

const tradeState = useAhTradesState();

const onBehalfOfClient = useOnBehalfOf();



const requestManager = useRequestManager({
  exposeToParent: ['loadWallet'],
  onRetryFromParentManager: (k: string) => {
    if (k === 'loadWallet') {
      onPriceChange();
    }
  },
});

const state = reactive({
  wallet: null as Wallet | null,
});

const buyCcy = computed(() => {
  return getBuyCcy(props.tradePriceResponse);
});

const sellCcy = computed(() => {
  return getSellCcy(props.tradePriceResponse);
});

const primaryRate = computed(() => {
  return getPrimaryCcy(props.tradePriceResponse);
});

const secondaryRate = computed(() => {
  return getSecondaryCcy(props.tradePriceResponse);
});

const isOverdraft = computed(() => {
  return state.wallet && sellCcy.value.clientAmount > state.wallet.balance;
});

const isPartnerUser = computed(() => {
  return !onBehalfOfClient.value && !tradeState.store.useAuthStore().isClientUser;
});

const isSettleToday = computed(() => {
  return isToday(parseISO(props.tradePriceResponse.settlementDate));
});

const ownerId = computed(() => {
  if (onBehalfOfClient.value) {
    return onBehalfOfClient.value.id;
  }
  return (
    tradeState.store.useAuthStore().loggedInIdentity?.client?.id ||
    tradeState.store.useAuthStore().loggedInIdentity?.partner?.id
  );
});

function getSettlementDate(date?: string, dateFormat: string = `${FULL_DATE_FORMAT} HH:mm`) {
  return date ? formatInTimeZone(new Date(date), 'GMT', dateFormat) : '-';
}

function onPriceChange() {
  requestManager.manager
    .newPromise(
      'loadWallet',
      tradeState.store.useWalletsStore().loadCurrencyWallet({
        currency: getSellCcy(props.tradePriceResponse).currency,
        owner: { isPartner: isPartnerUser.value, id: ownerId.value },
      })
    )
    .then(
      (wallet) => {
        state.wallet = wallet || null;
      },
      () => {
        state.wallet = null;
      }
    );
}

watch(
  () => props.tradePriceResponse,
  () => {
    onPriceChange();
  },
  { immediate: true }
);

return { __sfc: true,tradeState, onBehalfOfClient, props, requestManager, state, buyCcy, sellCcy, primaryRate, secondaryRate, isOverdraft, isPartnerUser, isSettleToday, ownerId, getSettlementDate, onPriceChange, formatHedgingInstrument, TradesFormattedCurrency }
}

})